import { formatNumber } from '@/helpers';
import { TopConversionsByBrand, TopConversionsByLocation, TopConversionsByProduct } from '@/types';
import React from 'react';

// Enum for the different methods of top converted
export enum TopConvertedMethod {
	PRODUCTS = 'product',
	BRANDS = 'brand',
	LOCATIONS = 'location',
	// CAMPAIGNS = 'campaigns',
}

type RenderFunc =
	| ((data: TopConversionsByProduct) => React.ReactNode)
	| ((data: TopConversionsByBrand) => React.ReactNode)
	| ((data: TopConversionsByLocation) => React.ReactNode);

export const TopConvertedMethodOptions: Record<TopConvertedMethod, string> = {
	[TopConvertedMethod.PRODUCTS]: 'Products',
	[TopConvertedMethod.BRANDS]: 'Brands',
	// [TopConvertedMethod.CAMPAIGNS]: 'Campaigns',
	[TopConvertedMethod.LOCATIONS]: 'Locations',
} as const;

type TableColumnData = {
	label: string;
	render: RenderFunc;
};

const formatQuantity = (quantity: number) => {
	if (quantity > 1) {
		return formatNumber(quantity, { precision: 0 });
	}
	return formatNumber(quantity, { precision: 2 });
};

export const TopConvertedMethodTableData: Record<TopConvertedMethod, TableColumnData[]> = {
	[TopConvertedMethod.PRODUCTS]: [
		{ label: 'Product Name', render: (data: TopConversionsByProduct) => <>{data.name}</> },
		{ label: 'Category', render: (data: TopConversionsByProduct) => <>{data.category}</> },
		{ label: '# Sold', render: (data: TopConversionsByProduct) => <>{formatQuantity(data.quantity ?? 0)}</> },
		{ label: 'Revenue Generated', render: (data: TopConversionsByProduct) => <>{formatNumber(data.revenue, { currency: true })}</> },
		{ label: 'SKU', render: (data: TopConversionsByProduct) => <>{data.skus.join(', ')}</> },
	],
	[TopConvertedMethod.BRANDS]: [
		{ label: 'Brand Name', render: (data: TopConversionsByBrand) => <>{data.name}</> },
		{ label: '# Sold', render: (data: TopConversionsByBrand) => <>{formatQuantity(data.quantity ?? 0)}</> },
		{ label: 'Revenue Generated', render: (data: TopConversionsByBrand) => <>{formatNumber(data.revenue, { currency: true })}</> },
	],
	// [TopConvertedMethod.CAMPAIGNS]: [
	// 	{ label: 'Campaign Name', render: () => <></> },
	// 	{ label: 'Revenue Generated', render: () => <></> },
	// 	{ label: 'SKU', render: () => <></> },
	// ],
	[TopConvertedMethod.LOCATIONS]: [
		{
			label: 'Location Name',
			render: (data: TopConversionsByLocation) => (
				<>
					{data.name} ({data.storeID})
				</>
			),
		},
		{ label: 'ID', render: (data: TopConversionsByLocation) => <>{data.storeID}</> },
		{ label: 'Address', render: (data: TopConversionsByLocation) => <>{[data.street, data.city, data.state, data.zip].join(', ')}</> },
		{ label: '# Sold', render: (data: TopConversionsByLocation) => <>{formatQuantity(data.quantity ?? 0)}</> },
		{ label: 'Revenue Generated', render: (data: TopConversionsByLocation) => <>{formatNumber(data.revenue, { currency: true })}</> },
	],
} as const;
